import { render, staticRenderFns } from "./video-popup-button.vue?vue&type=template&id=2ea3d630&scoped=true"
import script from "./video-popup-button.vue?vue&type=script&lang=js"
export * from "./video-popup-button.vue?vue&type=script&lang=js"
import style0 from "./video-popup-button.vue?vue&type=style&index=0&id=2ea3d630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea3d630",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HButton: require('/home/runner/work/frontpages/frontpages/component-library/src/components/atoms/buttons/h-button.vue').default})
